<template>
    <div class="loader">
        <div class="info">
            <img
                :src="menuComponents.logo.imageUrl"
                :alt="menuComponents.logo.logo"
                class="logo"
            />
            <ul class="pt-2">
                <li
                    :class="{
                        active: loadingState.stage === 1,
                        done: loadingState.stage > 1
                    }"
                >
                    {{ $t('printComponent.printLoadingGettingHiDefMap') }}
                </li>
                <li
                    :class="{
                        active: loadingState.stage === 2,
                        done: loadingState.stage > 2
                    }"
                >
                    {{ $t('printComponent.printLoadingStartPrinting') }}
                </li>
            </ul>
            <template v-if="loadingState.errors.length > 0">
                <h3>{{ $t('printComponent.printLoadingErrorListTitle') }}</h3>
                <ul class="pt-2">
                    <li
                        v-for="(error, index) in loadingState.errors"
                        :key="`error_${index}`"
                    >
                        {{ error }}
                    </li>
                </ul>
            </template>
            <div class="spinner-holder" v-if="loadingState.stage === 1">
                <b-spinner label="Spinning"></b-spinner>
            </div>
            <p>{{ loadingState.message }}</p>
            <b-button
                v-if="isMobileDevice && loadingState.stage === 3"
                variant="primary"
                @click="$emit('close')"
            >
                {{$t('btnCloseLabel')}}
            </b-button>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'PrintLoader',
        props: {
            loadingState: { type: Object, required: true },
            isMobileDevice: { type: Boolean, default: false }
        },
        data() {
            return { printShow: null };
        },
        computed: {
            ...mapState(['uiElements']),
            menuComponents: function () {
                return this.uiElements.menuBar.components;
            }
        }
    };
</script>

<style scoped lang="scss">
.loader {
    padding: 1em;
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 11;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
}
.logo {
    max-width: 120px;
}
.spinner-holder {
    display: flex;
    justify-content: space-around;
    margin-bottom: 1em;
}
.active {
    font-weight: bold;
}
.done {
    font-weight: bold;
    color: green;
}
h1 {
    margin-bottom: 1em;
}
ul {
    margin: auto;
    padding: revert;
    list-style: decimal;
    margin-bottom: 1em;
}
p {
    text-align: center;
}
@media print {
    .loader {
        display: none;
    }
}
</style>
